<template>
  <div class="nav-box" :class="{'nav-box-close':isClose}">
    <div class="nav-box-action">
      <img class="icon-open" src="../../assets/svg/icon-open.svg" alt="打开" />
      <img class="icon-close" src="../../assets/svg/icon-close.svg" alt="关闭" />
    </div>
    <div class="nav-box-center">
      <a v-if="project_name=='isoftstone'" class="nav-link" :href="customizeMHomeNavCareUrl||client_domain">
        <div class="icon-care">
          <img src="../../assets/svg/icon-home.svg" :alt="customizeMHomeNavCareText||'首页'" />
          <p v-text="customizeMHomeNavCareText||'首页'"></p>
        </div>
      </a>
      <a v-else class="nav-link" :href="customizeMHomeNavCareUrl||'/m/'">
        <div class="icon-care">
          <img src="../../assets/svg/icon-home.svg" :alt="customizeMHomeNavCareText||'首页'" />
          <p v-text="customizeMHomeNavCareText||'首页'"></p>
        </div>
      </a>
      <a v-if="hasNeigouNav && neigouurl" class="nav-link neigou_link" :href="neigouurl">
        <div class="icon-neigou">
          <img src="../../assets/svg/icon-neigou.svg" alt="内购" />
          <p>内购</p>
        </div>
      </a>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import config from "../../../../config/config.js";
import { httpGet } from "../../../../api/base.js";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      mouseButtonFlag: true, //是否是点击事件
      isClose: true,
      done: 0,
      isMix: 0,
      back_url: "",
      // back_last_url: "",
      aiguanhuaiurl: "",
      hasNeigouNav: false,
      bottomMenuStatusData: null,
      project_name : config.project_name,
      client_domain : config.client_domain
    };
  },
  props: ["ishome",'hasNeigou'],
  computed: {
    ...mapGetters({
      userLoginFinish: "userLoginFinish",
       customizeMHomeNavCareText:'getCustomizeMHomeNavCareText',
       customizeMHomeNavCareUrl:'getCustomizeMHomeNavCareUrl',
    }),
    
    // neigouurl() {
    //   let url = null;
    //   if (
    //     this.bottomMenuStatusData &&
    //     this.bottomMenuStatusData.navigation_url_data &&
    //     this.bottomMenuStatusData.navigation_url_data.NEIGOU &&
    //     this.bottomMenuStatusData.navigation_url_data.NEIGOU.link
    //   ) {
    //     url = this.bottomMenuStatusData.navigation_url_data.NEIGOU.link;
    //   }
    //   return url;
    // },
  },
  methods: {
    // initData() {
    //   httpGet(
    //     config.apps_domain +
    //       "/backend/api/fe/v3/private/j/home/bottomMenuStatus"
    //   ).then(result => {
    //     if (result) {
    //       this.bottomMenuStatusData = result.data.body;
    //     }
    //   });
    //   httpGet(config.apps_domain + "/api/fe/v1/private/p/ng/getNgNav").then(
    //     result => {
    //       if (result) {
    //         this.hasNeigouNav = result.data.body.NEIGOU == 1 ? true : false;
    //         if(this.hasNeigou === false){
    //             this.hasNeigouNav = false;
    //         }
    //       }
    //     }
    //   );
    // }
  },
  mounted() {
    let _this = this;

    $(".icon-close").on("click", function(ev) {
      ev.stopPropagation();
      console.log("icon-close click");
      _this.isClose = true;
    });

    let box_offset = {
      l: 0,
      t: 0
    };

    let disY = 0,
      t = 0;

    $(".icon-open").on("touchstart", function(ev) {
      console.log("touchstart.............");
      ev.stopPropagation();
      disY = ev.targetTouches[0].clientY;
    });
    $(".icon-open").on("touchmove", function(ev) {
      console.log("touchmove.............");
      if (
        ev.targetTouches[0].clientY < window.innerHeight - 100 &&
        ev.targetTouches[0].clientY > 100
      ) {
        t = ev.targetTouches[0].clientY - disY + box_offset.t;
      }
      $(".nav-box").css({
        transform: `translate(0px, ${t}px)`
      });
      _this.mouseButtonFlag = false;
    });
    $(".icon-open").on("touchend", function() {
      console.log("touchend.............");
      if (_this.mouseButtonFlag) {
        setTimeout(function() {
          console.log("setTimeout");
          _this.isClose = false;
        }, 50);
      }
      _this.mouseButtonFlag = true;
      if (t) {
        box_offset.t = t;
      }
    });

    $(".icon-open").on("mousedown", function(ev) {
      console.log("onmousedown.............");
      // ev.stopPropagation();
      disY = ev.clientY;

      document.onmousemove = function(ev) {
        console.log("onmousemove.............");
        if (ev.clientY < window.innerHeight - 100 && ev.clientY > 100) {
          t = ev.clientY - disY + box_offset.t;
        }
        $(".nav-box").css({
          transform: `translate(0px, ${t}px)`
        });
        _this.mouseButtonFlag = false;
      };
      document.onmouseup = function() {
        console.log("onmouseup.............");
        if (_this.mouseButtonFlag) {
          setTimeout(function() {
            console.log("setTimeout");
            _this.isClose = false;
          }, 50);
        }
        _this.mouseButtonFlag = true;
        document.onmousemove = null;
        document.onmouseup = null;
        if (t) {
          box_offset.t = t;
        }
      };

      return false;
    });
  },
  created() {
    // this.initData();
  }
};
</script>
<style  lang="scss" scoped>
@import "../../assets/css/_mixin.scss";
.clear {
  clear: both;
}
.nav-box {
  height: px2rem(131.25px);
  right: 0;
  bottom: 2rem;
  position: fixed;
  z-index: 901;
}
.nav-box-action {
  float: left;
  width: px2rem(75px);
  height: px2rem(75px);
  background: rgba(0, 0, 0, 0.5);
  margin-top: px2rem(31px);
  border-radius: px2rem(4.6875px) 0 0 px2rem(4.6875px);
}

.icon-open {
  display: none;
  width: px2rem(37.5px);
  height: px2rem(42.1875px);
  margin: px2rem(18.28125px) auto 0;
}
.icon-close {
  width: px2rem(37.5px);
  height: px2rem(42.1875px);
  margin: px2rem(18.28125px) auto 0;
}
.nav-box-center {
  float: left;
  background: rgba(0, 0, 0, 0.5);
  height: px2rem(131.25px);
  border-radius: px2rem(4.6875px) 0 0 px2rem(4.6875px);
}
.nav-box-center .nav-link {
  float: left;
  display: block;
}
.nav-box-center .icon-care {
  display: inline-block;
  width: px2rem(107.8125px);
  height: px2rem(131.25px);
  margin: 0 0 0 px2rem(7px);
  text-align: center;
}
.nav-box-center .icon-care img {
  width: px2rem(56.25px);
  height: px2rem(56.25px);
  margin: px2rem(23.4375px) auto 0;
}
.nav-box-center .icon-care p {
  color: white;
  margin: 0 auto;
}
.nav-box-center .icon-neigou {
  display: inline-block;
  width: px2rem(107.8125px);
  height: px2rem(131.25px);
  margin: 0 px2rem(7px) 0 0;
  text-align: center;
}
.nav-box-center .icon-neigou img {
  width: px2rem(56.25px);
  height: px2rem(56.25px);
  margin: px2rem(23.4375px) auto 0;
}
.nav-box-center .icon-neigou p {
  color: white;
  margin: 0 auto;
}
.nav-box-close .nav-box-action {
  right: 0;
}
.nav-box-close .icon-open {
  display: block;
}
.nav-box-close .icon-close {
  display: none;
}
.nav-box-close .nav-box-center {
  display: none;
}
</style>